import t from "react";
import { c as o, t as g } from "./app-a75c1d35.mjs";
import { I as u, a as I } from "./Image-d6406817.mjs";
import { L as h } from "./Link-479ac100.mjs";
import { C as b } from "./CallToAction-d24a74ed.mjs";
const N = "link-preview-card", L = "desktop", T = "image-container", S = "image", B = "badge", x = "link-wrapper", E = "preview-container", W = "preview-content", P = "card-title", f = "card-intro-text", y = "preview-link", H = "cta-hover", A = "save-button-container", M = "cta", O = "no-images-card", _ = "no-images-preview-content", R = "no-images-card-link-wrapper", D = "no-save-no-images-button-card-height", V = "no-save-button-card-link-wrapper", j = "no-save-no-images-link-wrapper", q = "no-save-button-preview-content", z = "no-save-button-cta", F = "hide-cta-on-mobile", e = {
  linkPreviewCard: N,
  desktop: L,
  imageContainer: T,
  image: S,
  badge: B,
  linkWrapper: x,
  previewContainer: E,
  previewContent: W,
  cardTitle: P,
  cardIntroText: f,
  previewLink: y,
  ctaHover: H,
  saveButtonContainer: A,
  cta: M,
  noImagesCard: O,
  noImagesPreviewContent: _,
  noImagesCardLinkWrapper: R,
  noSaveNoImagesButtonCardHeight: D,
  noSaveButtonCardLinkWrapper: V,
  noSaveNoImagesLinkWrapper: j,
  noSaveButtonPreviewContent: q,
  noSaveButtonCta: z,
  hideCtaOnMobile: F
};
function Y(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: p,
    imageProps: a,
    hasImages: n,
    hasSaveButton: r,
    showCTAOnMobile: v = !0,
    newTab: c = !0,
    badge: C
  } = l, k = o(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !r && !n,
    [e.hideCtaOnMobile]: !v
  }), w = o(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !r,
    [e.noSaveNoImagesLinkWrapper]: !n && !r
  });
  return /* @__PURE__ */ t.createElement("div", { className: k, "data-testid": "link-preview-container" }, n && a && /* @__PURE__ */ t.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ t.createElement(
    u,
    {
      credits: a.credits,
      src: a.src,
      width: a.width,
      height: a.height,
      altText: a.altText,
      imageLoader: a.imageLoader,
      className: e.image,
      styling: I.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ t.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ t.createElement("div", { className: w }, /* @__PURE__ */ t.createElement(
    h,
    {
      href: m,
      locale: p,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ t.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ t.createElement(
      G,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: r,
        newTab: c
      }
    ))
  )));
}
const G = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: p, newTab: a } = l, n = o(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), r = o(
    g.textsComponentTitleBold,
    e.cardTitle
  ), v = o(
    g.textsBodyText,
    e.cardIntroText
  ), c = o(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ t.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ t.createElement("h3", { className: r }, d), /* @__PURE__ */ t.createElement("p", { className: v }, i), /* @__PURE__ */ t.createElement(
    b,
    {
      containerClassName: c,
      as: "div",
      text: p,
      showCTAIcon: a
    }
  ));
};
export {
  Y as L
};
//# sourceMappingURL=LinkPreviewCard-2daafeaa.mjs.map
